module.exports = __webpack_public_path__ + "img/markImages-Icon-green.98d974c9.svg";